'use client'

import { Table } from '@tanstack/react-table'

import ClientPagination from './client-pagination'

interface DataTablePaginationProps<TData> {
  table: Table<TData>
  selectable?: boolean
}

export function DataTablePagination<TData>({
  table,
}: DataTablePaginationProps<TData>) {
  return (
    <div className="my-1 flex flex-col items-start justify-between px-2 sm:flex-row sm:items-center">
      <ClientPagination
        pageIndex={table.getState().pagination.pageIndex}
        pageCount={table.getPageCount()}
        pageSize={table.getState().pagination.pageSize}
        pageSizeOptions={[5, 10, 15, 20, 30, 40, 50, 100]}
        setPageIndex={table.setPageIndex}
        setPageSize={table.setPageSize}
      />
    </div>
  )
}
